<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "User Roles",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "User Roles",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "User Roles",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
        {
          key: "name",
          label: "Role Name",
          sortable: true,
        },
        {
          key: "permissions",
          label: "Permissions",
        },
      ],
      data: {
        name: "",
      },
      deleteRoles: {
        name: "",
        status: "",
        id: "",
      },
      editRoles: {
        name: "",
        id: "",
      },
      existingRole: [],
      nameError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("users", ["AllRoles", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.AllRoles.length;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.AllRoles.length;
  },
  methods: {
    ...mapActions({
      FetchRoles: "users/fetchRoles",
      AddRole: "users/addRole",
      EditRole: "users/editRole",
      DeleteRole: "users/deleteRole",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.AllRoles.length;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.resetError();
    },

    checkName() {
      //when creating a new one
      if (this.data.name != "") {
        this.existingRole = this.AllRoles.filter((Role) => {
          return Role.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingRole.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingRole = [];
      }
    },
    addRole(modal) {
      if (this.data.name == "") {
        this.nameError = "Role field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.existingRole.length) {
        this.nameError = this.data.name + " exists already Please";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.AddRole(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editRoles.id = values.item.id;
      this.editRoles.name = values.item.name;
    },
    showDeleteModal(values) {
      this.deleteRoles.id = values.item.id;
      this.deleteRoles.name = values.item.name;
      this.deleteRoles.status = values.item.status;
    },
    deleteRole(modal) {
      this.modal = modal;
      this.DeleteRole(this.deleteRoles);
      this.closeModal(modal);
    },
    editRole(modal) {
      if (this.editRoles.name == "") {
        this.nameError = "Role field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      this.modal = modal;
      this.EditRole(this.editRoles);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchRoles();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_roles')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">List of User Roles</h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-role-modal
                  class="btn btn-sm btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_roles')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="AllRoles ? AllRoles : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(actions)="data">
                  <b-dropdown size="sm" disabled v-if="data.item.id == 1">
                    <template v-slot:button-content>
                      Action
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                  </b-dropdown>
                  <b-dropdown size="sm" v-else>
                    <template v-slot:button-content>
                      Action
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item>
                      <a
                        href="#"
                        v-b-modal.edit-role-modal
                        @click="showEditModal(data)"
                        class="text-primary"
                        v-if="
                          getCurrentUser.permissions.find((item) =>
                            item.permission.includes('edit_roles')
                          )
                        "
                      >
                        <i class="fa fa-edit"></i> Edit Role
                      </a>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <a
                        href="#"
                        v-if="data.item.status"
                        v-b-modal.delete-role-modal
                        @click="showDeleteModal(data)"
                        class="text-danger"
                      >
                        <i class="fa fa-trash"></i> Deactivate
                      </a>
                      <a
                        href="#"
                        v-else
                        v-b-modal.delete-role-modal
                        @click="showDeleteModal(data)"
                        class="text-success"
                      >
                        <i class="fa fa-cog"></i> Activate
                      </a>
                    </b-dropdown-item>
                    <b-dropdown-item>
                      <router-link
                        :to="`/users/roles/permissions/${data.item.id}`"
                        class="text-secondary"
                        v-if="
                          getCurrentUser.permissions.find((item) =>
                            item.permission.includes('assign_permissions')
                          )
                        "
                      >
                        <i class="fa fa-cog"></i> Permissions
                      </router-link>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <template #cell(permissions)="data">
                  <div
                    style="max-width: 50rem"
                    v-for="(permission, index) in data.item.perm"
                    :key="index"
                  >
                    <strong
                      >{{ permission.parent.replaceAll("_", " ") }}: </strong
                    >{{ permission.permission.replaceAll(",", ", ") }}
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal
        id="add-role-modal"
        hide-footer
        @hidden="resetAddModal"
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('add_roles')
          )
        "
      >
        <template #modal-title> Add New Role </template>
        <div class="form-group mb-3">
          <label>Role Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Role Name"
              class="form-control"
              @keyup="checkName"
              @input="resetError"
              v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('add-role-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-sm btn-outline-primary"
            disabled
          >
            <b-spinner variant="light" small label="Spinning"></b-spinner>
            Submiting...
          </button>
          <button
            type="button"
            v-else
            class="btn btn-sm btn-outline-primary"
            @click="addRole('add-role-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal
        id="edit-role-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('edit_roles')
          )
        "
      >
        <template #modal-title> Edit Role {{ editRoles.name }}</template>
        <div class="form-group mb-3">
          <label>Role Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError"
              v-model="editRoles.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            data-dismiss="modal"
            @click="closeModal('edit-role-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="SaveStatus"
            type="button"
            class="btn btn-sm btn-outline-success"
            disabled
          >
            <b-spinner variant="success" small label="Saving"></b-spinner>
            Saving...
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm btn-outline-success"
            @click="editRole('edit-role-modal')"
          >
            <i class="fa fa-save"></i>
            Save Changes
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete role starts -->
      <b-modal
        id="delete-role-modal"
        hide-footer
        v-if="
          getCurrentUser.permissions.find((item) =>
            item.permission.includes('deactivate_role')
          )
        "
      >
        <template #modal-title>
          <h4 class="text-danger" v-if="deleteRoles.status == '1'">
            Deactivate Role {{ deleteRoles.name }}
          </h4>
          <h4 class="text-primary" v-else>
            Activate Role {{ deleteRoles.name }}
          </h4>
        </template>
        <div class="form-group mb-3">
          <div class="input-group">
            <h6 v-if="deleteRoles.status == '1'">
              Do you want to Deactivate Role {{ deleteRoles.name }}? <br />
              Click Proceed Button to delete.
            </h6>
            <h6 v-else>
              Do you want to Activate Role {{ deleteRoles.name }}? <br />
              Click Proceed Button to Activate.
            </h6>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-role-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            v-if="deleteRoles.status == '1'"
            type="button"
            class="btn btn-sm btn-danger"
            @click="deleteRole('delete-role-modal')"
          >
            <i class="fa fa-trash"></i> Deactivate
          </button>
          <button
            v-else
            type="button"
            class="btn btn-sm btn-primary"
            @click="deleteRole('delete-role-modal')"
          >
            <i class="fa fa-cog"></i> Activate
          </button>
          <b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
